"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var H_1 = __importDefault(require("../../../common/Typography/H"));
var RemoveCircleIcon_1 = __importDefault(require("../../../common/Icons/RemoveCircleIcon"));
var banned_info_module_scss_1 = __importDefault(require("./banned-info.module.scss"));
var BannedInfo = function () {
    return (react_1.default.createElement(H_1.default, { level: 3, className: banned_info_module_scss_1.default.root },
        react_1.default.createElement("span", { className: banned_info_module_scss_1.default.icon },
            react_1.default.createElement(RemoveCircleIcon_1.default, null)),
        react_1.default.createElement("span", null,
            "\u0414\u0430\u043D\u043D\u044B\u0439 \u0434\u0438\u0437\u0430\u0439\u043D \u0431\u044B\u043B \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D \u043F\u043E \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044E \u043F\u0440\u0430\u0432\u043E\u043E\u0431\u043B\u0430\u0434\u0430\u0442\u0435\u043B\u044F. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0442\u043E\u0432\u0430\u0440 \u0441 \u043B\u044E\u0431\u044B\u043C \u0441\u0432\u043E\u0438\u043C \u043F\u0440\u0438\u043D\u0442\u043E\u043C \u0432",
            ' ',
            react_1.default.createElement("a", { href: "/products" }, "\u043D\u0430\u0448\u0435\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0435"),
            ".")));
};
exports.default = BannedInfo;
